module.exports = __webpack_public_path__ + "media/A friend to remember (Mikaela's theme).25d60816.mp3";